import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selected: {},
  dashboard: {},
  dashboardCounts: {},
  proposalAdded: false,
  proposalUpdated: false,
  proposalRemoved: false,
};

const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  reducers: {
    getProposals(state, action) {
      state.list = action.payload.proposals;
      state.meta = action.payload.meta;
    },
    getProposalById(state, action) {
      state.selected = action.payload;
    },
    addProposal(state, action) {
      state.proposalAdded = true;
    },
    updateProposal(state, action) {
      state.proposalUpdated = true;
    },
    removeProposal(state, action) {
      state.proposalRemoved = true;
    },
    getProposalDashboard(state, action) {
      state.dashboard = action.payload;
    },
    getProposalDashboardCount(state, action) {
      state.dashboardCounts = action.payload;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const proposalActions = proposalSlice.actions;
export default proposalSlice;
